var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60938 1.23438V8.11523L10.0215 5.70312L10.4531 5.27148L11.3164 6.10938L10.8848 6.54102L7.43164 9.99414L7 10.4258L6.56836 9.99414L3.11523 6.54102L2.68359 6.10938L3.54688 5.27148L3.97852 5.70312L6.39062 8.11523V1.23438V0.625H7.60938V1.23438ZM3.75 8.34375L4.96875 9.5625H1.71875V12.4062H12.2812V9.5625H9.00586L10.2246 8.34375H12.2812H13.5V9.5625V12.4062V13.625H12.2812H1.71875H0.5V12.4062V9.5625V8.34375H1.71875H3.75ZM11.4688 10.9844C11.4688 11.3398 11.1895 11.5938 10.8594 11.5938C10.5039 11.5938 10.25 11.3398 10.25 10.9844C10.25 10.6543 10.5039 10.375 10.8594 10.375C11.1895 10.375 11.4688 10.6543 11.4688 10.9844Z",
    fill: "#0962AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.53c10af888c36377a17c5b7a4b0da46c.svg";
export { ForwardRef as ReactComponent };